var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDisk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3333 14.5833L17.7569 6.22479C17.6664 4.91253 17.6211 4.2564 17.3367 3.75902C17.0863 3.32111 16.7093 2.9692 16.2552 2.74952C15.7394 2.5 15.0817 2.5 13.7664 2.5H6.23364C4.91826 2.5 4.26057 2.5 3.7448 2.74952C3.2907 2.9692 2.91368 3.32111 2.66328 3.75902C2.37887 4.2564 2.33362 4.91253 2.24312 6.22479L1.66667 14.5833M18.3333 14.5833C18.3333 16.1942 17.0275 17.5 15.4167 17.5H4.58333C2.9725 17.5 1.66667 16.1942 1.66667 14.5833M18.3333 14.5833C18.3333 12.9725 17.0275 11.6667 15.4167 11.6667H4.58333C2.9725 11.6667 1.66667 12.9725 1.66667 14.5833M5 14.5833H5.00833M10 14.5833H15",
    stroke: "currentColor",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisk);
export default __webpack_public_path__ + "static/media/disk.b8f7f7618284353d79e14e0f64aaace9.svg";
export { ForwardRef as ReactComponent };